var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1,.cls-4{fill:#00b0db}.cls-2{fill:none}.cls-3,.cls-4{stroke:none}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-860 -307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M10.254-29.48H-10.62l-3.3-58.044h27.4zm4.211 18.616a11.357 11.357 0 0 1-3.937 8.911Q6.592 1.526 0 1.526a15.347 15.347 0 0 1-10.468-3.54 11.26 11.26 0 0 1-4.059-8.85 10.84 10.84 0 0 1 3.937-8.7Q-6.653-22.888 0-22.888q6.47 0 10.468 3.326a10.772 10.772 0 0 1 3.997 8.698z",
    className: "cls-1",
    "data-name": "Path 4",
    transform: "translate(960 454)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_3",
    className: "cls-2",
    "data-name": "Path 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0A100 100 0 1 1 0 100 100 100 0 0 1 100 0z",
    className: "cls-3",
    transform: "translate(860 307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 13c-47.972 0-87 39.028-87 87s39.028 87 87 87 87-39.028 87-87-39.028-87-87-87m0-13c55.228 0 100 44.772 100 100s-44.772 100-100 100S0 155.228 0 100 44.772 0 100 0z",
    className: "cls-4",
    transform: "translate(860 307)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e69d1934f74ea40242f6f4c0a490d386.svg";
export { ForwardRef as ReactComponent };